import { Box, Box as CloseButtonArea} from "@mui/material"
import { Icon } from "assets/Icons_"
import styled from "styled-components"
import Container from "./Container"
import Successfull from "../pages/Successfull"
import Form from "../pages/Form"
import { useState } from "react"
import { AnimatePresence } from "framer-motion"
import { motion } from "framer-motion"

const EventInfo = ({ setShowPopup }) => {
  const [step, setStep] = useState(1);

  const prop = { step, setStep }

  
  const animation = {
    initial   : { height: 0 },
    animate   : { height: "auto" },
    exit      : { height: 0 },
    transition: { duration: 1, ease: "easeInOut" }
  };


  return (

      <Section as       = {motion.div} {...animation} key={'eventInfopopup'}>
          <CloseButtonArea sx={CloseButtonAreaCss}>
              <Icon click={ ()=> setShowPopup(false) } icon  = {"close"} style = {{ fontSize: '16px' }} isFaIcon = {true} color = "#FFF" />
          </CloseButtonArea>

              <Box sx={{ overflowY: 'auto' }}>
                  { step === 1 && <Container key="step1" { ...prop } /> }
                  { step === 2 && <Form key="step2" { ...prop } /> }
                  { step === 3 && <Successfull key="step3" { ...prop } /> }
              </Box>
      </Section>
  )
}

export default EventInfo

const Section = styled.section`
    max-width: 672px;
    width: 100%;
    border-radius: 24px;
    overflow: auto;
    margin-top: 8px;
    // max-height: calc(100vh - 286px)
`
const CloseButtonAreaCss = {
    height: '40px',
    backgroundColor: clr.primary,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItem: 'center',
    paddingRight: '12px'
} 
